export enum MIMEType {
  HL7 = 'application/hl7-sda+xml',
  X_CCR = 'application/x-ccr',
  PDF = 'application/pdf',
  JPEG = 'application/jpeg',
  TIFF = 'application/tiff',
  PNG = 'application/png',
}
